import accountReducer from './accountReducer';
import adminReducer from './adminReducer';
import collectionReducer from './collectionReducer';
import contractReducer from './contractReducer';
import currencyReducer from './currencyReducer';
import customerReducer from './customerReducer';
import detailsPanelReducer from './detailsPanelReducer';
import errorsReducer from './errorsReducer';
import integrationsReducer from './integrationsReducer';
import invoiceReducer from './invoiceReducer';
import invoicingReducer from './invoicingReducer';
import loginReducer from './loginReducer';
import modalReducer from './modalReducer';
import notificationsReducer from './notificationsReducer';
import onBoardingReducer from './onBoardingReducer';
import paymentReducer from './paymentReducer';
import permsReducer from './permsReducer';
import portalReducer from './portalReducer';
import productsReducer from './productsReducer';
import remindersReducer from './remindersReducer';
import reportsReducer from './reportsReducer';
import sidebarReducer from './sidebarReducer';
import templateReducer from './templateReducer';
import testReducer from './testReducer';
import themeReducer from './themeReducer';
import topbarNotificationsReducer from './topbarNotificationsReducer';
import dialogReducer from './dialogReducer';
import appVersionReducer from './appVersionReducer';
import sourcePaymentsReducer from './sourcePaymentsReducer';
import bulkOperationsReducer from './bulkOperationsReducer';

export {
  accountReducer,
  adminReducer,
  collectionReducer,
  contractReducer,
  currencyReducer,
  customerReducer,
  detailsPanelReducer,
  errorsReducer,
  integrationsReducer,
  invoiceReducer,
  invoicingReducer,
  loginReducer,
  modalReducer,
  notificationsReducer,
  onBoardingReducer,
  paymentReducer,
  permsReducer,
  portalReducer,
  productsReducer,
  remindersReducer,
  reportsReducer,
  sidebarReducer,
  templateReducer,
  testReducer,
  themeReducer,
  topbarNotificationsReducer,
  dialogReducer,
  appVersionReducer,
  sourcePaymentsReducer,
  bulkOperationsReducer
}; // END export



// WEBPACK FOOTER //
// ./src/redux/reducers/index.js